import { cn } from "@/engine/support/classNames";
import { PALETTES } from "@/engine/support/palette";
import { useTheme } from "@/hooks/useTheme";

/**
 * A night scene stays night (#956).
 *
 * The landing's fires are drawn from the palette's tokens, and in a light
 * palette those are a pale sky, grey stars and a washed-out flame. So in a
 * light palette the scene below is drawn with Midnight's tokens — the
 * stylesheet keys a palette on any element that carries `dark` and
 * `data-palette`, not only on the document — and in a dark palette it keeps the
 * visitor's own colours.
 */
export function NightScope({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  const { palette } = useTheme();
  const light = PALETTES.find(({ id }) => id === palette)?.mode === "light";
  return (
    <div
      className={cn(light && "dark", className)}
      data-palette={light ? "midnight" : undefined}
    >
      {children}
    </div>
  );
}
